/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Changes_TitleInputs */

const es_privacy_policy_changes_title = /** @type {(inputs: Privacy_Policy_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Cambios en esta Politica`)
};

const en_privacy_policy_changes_title = /** @type {(inputs: Privacy_Policy_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Changes to This Policy`)
};

/**
* | output |
* | --- |
* | "10. Changes to This Policy" |
*
* @param {Privacy_Policy_Changes_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_changes_title = /** @type {((inputs?: Privacy_Policy_Changes_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Changes_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_changes_title(inputs)
	return en_privacy_policy_changes_title(inputs)
});
export { privacy_policy_changes_title as "privacy_policy.changes.title" }